import { Application } from '@yulintu/freesia-bootstrap';
import React, { useState, useEffect, useContext } from 'react';
import "./index.less";

export default function Footer(props) {
    const {title,style={}} = props;
    
    //const context = useContext(Application.Context);
    // const renderExtras = (extras) => {

    //     const factory = context.factory;
    //     if (!factory)
    //         return null;

    //     const addons = (extras || []).map((c, i) => {
    //         if (!c.template)
    //             return null;

    //         let component = null;
    //         if (typeof c.template === "string")
    //             component = factory.load(c.template, { ...c.props, metadata: c, key: i }, { key: i });

    //         return component;

    //     }).filter(c => c);

    //     return addons;
    // }
    
    return <div className='layout-h center footer-container'>
        <div className='footer-left' ></div>
        <div className='footer-center fill' style={{...style}}>{title}</div>
        <div className='footer-right'></div>
    </div>
}